import SuggestionCategory from './SuggestionCategory'
export default SuggestionCategory
